namespace appn.views.platform.environments {

    class InitArgs {
        columnCount: number = 0;
        columnWidths: number = 0;
        platformCreateEnvironment: string = emptyString;
        platformAddExistingEnvironment: string = emptyString;
    }

    let _initArgs: InitArgs;

    let _dataTable: any = null;

    export function init(args: InitArgs): void {
        _initArgs = args;
        createDataTable();
    }

    function createDataTable() {
        _dataTable = appn.dataTable.create('.dataTable', {
            //sDom: '<"dataTables_actions">frtlip',
            iDisplayLength: 25,
            bProcessing: true,
            bServerSide: true,
            sAjaxSource: 'EnvironmentsDataTable',
            fnServerData: function(data: any, callback: any) {
                data.push(appn.dataTable.getStateOrDefault('sCustom_0', $('#sCustom_0').prop('checked'))); // Show Archived filter
            },
            autoWidth: false,
            aoColumns: getDtColConfiguration(),
            fnInitComplete: function() {
                // Add in inactive checkbox in filter row
                $('#addexisting').click(function(event) {
                    event.preventDefault();
                    appn.location.navTo(_initArgs.platformAddExistingEnvironment);
                });

                $('#addnew').click(function(event) {
                    event.preventDefault();
                    appn.location.navTo(_initArgs.platformCreateEnvironment);
                });

                // Add in inactive checkbox in filter row
                $('.dataTables_filter').prepend(appn.elementBuilder.buildCheckbox(appn.strings.showRetired, 'saveMeState', 'sCustom_0')).append($('.dt-action-button'));

                appn.dataTable.addSearchPlaceholder(T('Filter results where the Environments <b>Name or Status</b> contains a keyword typed in here.'));

                $('.dataTables_controls_start').append($('.dt-action-title'));

                appn.saveMeState.init(function() {
                    _dataTable.fnDraw(false);
                },
                    function() {
                        _dataTable.fnDraw(false);
                    }, '.dataTables_filter');
            },
            fnDrawCallback: function() {
                // Hide all links with a class of rowOptions
                $('.rowOptions').hide();

                // act upon all table rows with a class of data
                $('.dataTable tr').hover(function() {
                    // at this point, 'this' is the table row that is being hovered
                    // we can use the find function to locate the class rowOptions and show it.
                    $(this).find('.rowOptions').show();
                }, function() {
                    // the second argument of the hover function is what should happen
                    // when the mouse hovers out of the table row. In this case, we want
                    // to find the class again and hide it.
                    $(this).find('.rowOptions').hide();
                });
            }
        });
    }

    function getDtColConfiguration(): Array<IDTColumns> {
        const aoColumns: Array<IDTColumns> = [];

        aoColumns.push({ bSortable: true, sWidth: '35%' } as IDTColumns);

        for (let i = 1; i < _initArgs.columnCount; i++)
            aoColumns.push({ bSortable: true, sWidth: `${_initArgs.columnWidths}%` } as IDTColumns);

        aoColumns.push({ bSortable: true, sWidth: '15%' } as IDTColumns,
            { bSortable: true, sWidth: '15%' } as IDTColumns);

        return aoColumns;
    }
}
